import {
  generateSearchAccordionOpenSettingKey,
  generateSearchHistoryKey,
} from '@/features/search/_utils/local-storage';

const FEATURE_NAME = 'comment';

export const COMMENT_SEARCH_HISTORY_KEY =
  generateSearchHistoryKey(FEATURE_NAME);

export const COMMENT_SEARCH_ACCORDION_OPEN_SETTING_KEY =
  generateSearchAccordionOpenSettingKey(FEATURE_NAME);

export const COMMENT_FILTER_SIDER_KEY = 'comment.filter-sider';
